const language = {
  UNDEFINED: '未定義',

  AFRIKAANS: '南非荷蘭語',
  AMHARIC: '阿姆哈拉語',
  ARABIC: '阿拉伯語',
  MODERN_STANDARD_ARABIC: '現代標準阿拉伯語',

  AZERBAIJANI: '亞塞拜然語',
  BULGARIAN: '保加利亞語',
  BENGALI: '孟加拉語',
  CATALAN: '加泰隆尼亞語',
  CZECH: '捷克語',
  DANISH: '丹麥語',
  GERMAN: '德語',
  GREEK: '希臘語',

  ENGLISH: '英語',
  AMERICAN_ENGLISH: '英語（美式）',
  BRITISH_ENGLISH: '英語（英式）',

  SPANISH: '西班牙語',
  EUROPEAN_SPANISH: '西班牙語（歐洲）',
  LATIN_AMERICAN_SPANISH: '西班牙語（拉丁美洲）',

  ESTONIAN: '愛沙尼亞語',
  PERSIAN: '波斯語',
  FINNISH: '芬蘭語',
  FILIPINO: '菲律賓語',
  FRENCH: '法語',
  CANADIAN_FRENCH: '法語（加拿大）',

  GUJARATI: '古吉拉特語',
  HEBREW: '希伯來語',
  HINDI: '印地語',
  CROATIAN: '克羅埃西亞語',
  HUNGARIAN: '匈牙利語',
  ARMENIAN: '亞美尼亞語',
  INDONESIAN: '印尼語',
  ICELANDIC: '冰島語',
  ITALIAN: '義大利語',
  JAPANESE: '日語',
  GEORGIAN: '喬治亞語',
  KAZAKH: '哈薩克語',
  KHMER: '高棉語',
  KANNADA: '卡納達語',
  KOREAN: '韓語',
  KIRGHIZ: '吉爾吉斯語',
  LAO: '寮國語',

  LITHUANIAN: '立陶宛語',
  LATVIAN: '拉脫維亞語',

  MACEDONIAN: '馬其頓語',
  MALAYALAM: '馬拉雅拉姆語',
  MONGOLIAN: '蒙古語',
  MARATHI: '馬拉地語',
  MALAY: '馬來語',
  BURMESE: '緬甸語',
  NEPALI: '尼泊爾語',

  DUTCH: '荷蘭語',

  NORWEGIAN: '挪威語',

  PUNJABI: '旁遮普語',
  POLISH: '波蘭語',

  PORTUGUESE: '葡萄牙語',
  BRAZILIAN_PORTUGUESE: '葡萄牙語（巴西）',
  EUROPEAN_PORTUGUESE: '葡萄牙語（葡萄牙）',

  ROMANIAN: '羅馬尼亞語',
  RUSSIAN: '俄語',
  SINHALA: '僧伽羅語',
  SLOVAK: '斯洛伐克語',
  SLOVENIAN: '斯洛維尼亞語',
  ALBANIAN: '阿爾巴尼亞語',
  SERBIAN: '塞爾維亞語',
  SERBIAN_LATIN: '塞爾維亞語（拉丁字母）',

  SWEDISH: '瑞典語',
  SWAHILI: '斯瓦希里語',

  TAMIL: '泰米爾語',
  TELUGU: '泰盧固語',
  THAI: '泰語',
  TURKISH: '土耳其語',

  UKRAINIAN: '烏克蘭語',
  URDU: '烏爾都語',

  UZBEK: '烏茲別克語',
  VIETNAMESE: '越南語',
  CHINESE: '中文',
  SIMPLIFIED_CHINESE: '中文（簡體）',
  TRADITIONAL_CHINESE: '中文（繁體）',

  ZULU: '祖魯語'
};

export default language;
